import CloseIcon from "@material-ui/icons/Close";
import color from "color";
import styled from "styled-components";

export const Container = styled.div`
  z-index: 9;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: ${({ theme }) =>
    color(theme.colors.black.normal)
      .alpha(0.4)
      .toString()};
`;

interface ContentProps {
  defaultWidth?: string;
}

export const Content = styled.div<ContentProps>`
  border-radius: 10px;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white.normal};
  margin: auto;
  padding: 0;
  width: ${({ defaultWidth }) => (defaultWidth ? `${defaultWidth}` : "50%")};
  max-width: 1280px;
  overflow-y: auto;
  -webkit-animation-name: ${({ theme }) => theme.animation.name};
  -webkit-animation-duration: 0.4s;
  animation-name: ${({ theme }) => theme.animation.name};
  animation-duration: 0.4s;

  @media ${({ theme }) => theme.devices.tablet} {
    max-height: 80vh;
    max-width: 90%;
    width: ${({ defaultWidth }) => (defaultWidth ? `${defaultWidth}` : "70%")};
    max-width: 512px;

    max-height: 80vh;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
    }
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    width: ${({ defaultWidth }) =>
      defaultWidth ? `${defaultWidth}` : "fit-content"};
    min-width: 70%;
    max-width: 90%;
  }
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.white.normal};
  letter-spacing: 1px;
  font-weight: 800;
  font-family: ${({ theme }) => theme.fonts.inter} !important;

  @media ${({ theme }) => theme.devices.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

interface IProps {
  isWithTitle?: boolean;
}

export const Header = styled.div<IProps>`
  border-radius: 5px 5px 0 0;
  padding: 2px 16px;
  background-color: ${({ isWithTitle, theme }) =>
    isWithTitle ? theme.colors.green.light : "transparent"};
  color: ${({ theme }) => theme.colors.white.normal};
  display: flex;
  flex-direction: row;
  justify-content: ${({ isWithTitle }) =>
    isWithTitle ? "space-between" : "end"};
  align-items: center;
  position: relative;
`;

export const Close = styled(CloseIcon).attrs(props => ({
  fontSize: "large",
}))`
  z-index: 100;
  color: ${({ theme }) => theme.colors.white.normal};
  float: right;
  font-size: ${({ theme }) => theme.fontSize.md2};
  font-weight: bold;
  &:hover {
    color: ${({ theme }) => theme.colors.gray.dark};
    text-decoration: none;
    cursor: pointer;
  }

  &:focus {
    text-decoration: none;
    cursor: pointer;
  }
`;
